/**
 * Слой комментариев на холсте: выноски с текстом поверх всего чертежа.
 *
 * Рисуется последним из слоёв чертежа: комментарий указывает на что-то на плане и не
 * должен прятаться под мебелью или проводкой. Выключенный слой не рисуется. Как выглядит
 * выноска, знает `CommentShape`; слой только раздаёт выделение, захват, правку и меню.
 */
import type { MouseEvent, PointerEvent } from "react";
import type { PlanComment } from "@/shared/plan";
import { CommentShape, type CommentPart } from "@/widgets/comments";
import { SelectionKind, Tool, useEditorStore } from "../../editor";

interface Props {
	comments: PlanComment[];
	mmPerPx: number;
	/** Комментарий, текст которого сейчас правят в окошке */
	editingId: string | null;
	onCommentPointerDown: (e: PointerEvent<Element>, comment: PlanComment, part: CommentPart) => void;
	onCommentDoubleClick: (e: MouseEvent<Element>, comment: PlanComment) => void;
	onCommentMenu: (comment: PlanComment) => void;
}

export const CommentsLayer2D = ({
	comments,
	mmPerPx,
	editingId,
	onCommentPointerDown,
	onCommentDoubleClick,
	onCommentMenu,
}: Props) => {
	const selection = useEditorStore((s) => s.selection);
	const tool = useEditorStore((s) => s.tool);
	return (
		<g>
			{comments.map((comment) => (
				<CommentShape
					key={comment.id}
					comment={comment}
					selected={selection?.kind === SelectionKind.Comment && selection.id === comment.id}
					editing={editingId === comment.id}
					mmPerPx={mmPerPx}
					interactive={tool === Tool.Select || tool === Tool.Erase}
					onPointerDown={(e, part) => onCommentPointerDown(e, comment, part)}
					onDoubleClick={(e) => onCommentDoubleClick(e, comment)}
					onMenu={() => onCommentMenu(comment)}
				/>
			))}
		</g>
	);
};
